
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("9ewR5"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("9ewR5", function(module, exports) {

let $6b8ee8390e493747$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b8ee8390e493747$var$load("cRtGo"),
    $6b8ee8390e493747$var$load("3Zwna"),
    $6b8ee8390e493747$var$load("di1Y5"),
    $6b8ee8390e493747$var$load("aYECQ"),
    $6b8ee8390e493747$var$load("55OBD"),
    $6b8ee8390e493747$var$load("gfGrm"),
    $6b8ee8390e493747$var$load("24u6w"),
    $6b8ee8390e493747$var$load("27glK"),
    $6b8ee8390e493747$var$load("bvY53"),
    $6b8ee8390e493747$var$load("l8Ar8"),
    $6b8ee8390e493747$var$load("gFEtJ"),
    $6b8ee8390e493747$var$load("7jSfd"),
    $6b8ee8390e493747$var$load("4HZlX"),
    $6b8ee8390e493747$var$load("kDqHr"),
    $6b8ee8390e493747$var$load("gT8XU"),
    $6b8ee8390e493747$var$load("3GuOt"),
    $6b8ee8390e493747$var$load("3Mspc"),
    $6b8ee8390e493747$var$load("9aQIt"),
    $6b8ee8390e493747$var$load("XZauT"),
    $6b8ee8390e493747$var$load("4S1SF"),
    $6b8ee8390e493747$var$load("lm9Lt"),
    $6b8ee8390e493747$var$load("9wPDc"),
    $6b8ee8390e493747$var$load("1MWOL"),
    $6b8ee8390e493747$var$load("6fQco"),
    $6b8ee8390e493747$var$load("aOY32"),
    $6b8ee8390e493747$var$load("3MYQs"),
    $6b8ee8390e493747$var$load("6SWFK"),
    $6b8ee8390e493747$var$load("5zapo"),
    $6b8ee8390e493747$var$load("jiFtb"),
    $6b8ee8390e493747$var$load("9atVd"),
    $6b8ee8390e493747$var$load("iivLa"),
    $6b8ee8390e493747$var$load("6wr18"),
    $6b8ee8390e493747$var$load("dek7I"),
    $6b8ee8390e493747$var$load("6iz6l"),
    $6b8ee8390e493747$var$load("4SCW2"),
    $6b8ee8390e493747$var$load("fdKpi"),
    $6b8ee8390e493747$var$load("ffEVr"),
    $6b8ee8390e493747$var$load("hhss7"),
    $6b8ee8390e493747$var$load("l22f4"),
    $6b8ee8390e493747$var$load("eTYdV"),
    $6b8ee8390e493747$var$load("Wowvf"),
    $6b8ee8390e493747$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("2jLeQ"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("2jLeQ", function(module, exports) {

let $1b01fface3d898fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b01fface3d898fa$var$load("cRtGo"),
    $1b01fface3d898fa$var$load("3Zwna"),
    $1b01fface3d898fa$var$load("6wr18"),
    $1b01fface3d898fa$var$load("3j4Bc"),
    $1b01fface3d898fa$var$load("27glK"),
    $1b01fface3d898fa$var$load("bvY53"),
    $1b01fface3d898fa$var$load("ffEVr"),
    $1b01fface3d898fa$var$load("fIjMV"),
    $1b01fface3d898fa$var$load("psI7s"),
    $1b01fface3d898fa$var$load("6bVVs"),
    $1b01fface3d898fa$var$load("7mo6o"),
    $1b01fface3d898fa$var$load("eTYdV"),
    $1b01fface3d898fa$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("34UV0"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("34UV0", function(module, exports) {

let $23dde5a491238968$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $23dde5a491238968$var$load("l0guZ"),
    $23dde5a491238968$var$load("c0JsV"),
    $23dde5a491238968$var$load("h3ABO"),
    $23dde5a491238968$var$load("6fwHW"),
    $23dde5a491238968$var$load("e7eRf"),
    $23dde5a491238968$var$load("61GLz"),
    $23dde5a491238968$var$load("55zKk"),
    $23dde5a491238968$var$load("dafa3"),
    $23dde5a491238968$var$load("iEUHW"),
    $23dde5a491238968$var$load("kbwlB"),
    $23dde5a491238968$var$load("2YffH"),
    $23dde5a491238968$var$load("9XOeB"),
    $23dde5a491238968$var$load("xu7ej"),
    $23dde5a491238968$var$load("iQ4FP"),
    $23dde5a491238968$var$load("T6sdO"),
    $23dde5a491238968$var$load("6bjJA"),
    $23dde5a491238968$var$load("l92ZI"),
    $23dde5a491238968$var$load("9anPW"),
    $23dde5a491238968$var$load("6wmiZ"),
    $23dde5a491238968$var$load("im1VN"),
    $23dde5a491238968$var$load("eD3Si"),
    $23dde5a491238968$var$load("7usgn"),
    $23dde5a491238968$var$load("c7Big"),
    $23dde5a491238968$var$load("2SaXB"),
    $23dde5a491238968$var$load("gnDXu"),
    $23dde5a491238968$var$load("5XC9j"),
    $23dde5a491238968$var$load("di1Y5"),
    $23dde5a491238968$var$load("aYECQ"),
    $23dde5a491238968$var$load("gfGrm"),
    $23dde5a491238968$var$load("24u6w"),
    $23dde5a491238968$var$load("l8Ar8"),
    $23dde5a491238968$var$load("lTK3c"),
    $23dde5a491238968$var$load("1WXdc"),
    $23dde5a491238968$var$load("b2FtX"),
    $23dde5a491238968$var$load("2tuEe"),
    $23dde5a491238968$var$load("bQal6"),
    $23dde5a491238968$var$load("a6WoQ"),
    $23dde5a491238968$var$load("hhss7"),
    $23dde5a491238968$var$load("6iz6l"),
    $23dde5a491238968$var$load("4SCW2"),
    $23dde5a491238968$var$load("cPyTz"),
    $23dde5a491238968$var$load("53ejW"),
    $23dde5a491238968$var$load("hdYRX"),
    $23dde5a491238968$var$load("ftrp4"),
    $23dde5a491238968$var$load("5aEHs"),
    $23dde5a491238968$var$load("9HZKr"),
    $23dde5a491238968$var$load("cRtGo"),
    $23dde5a491238968$var$load("6wr18"),
    $23dde5a491238968$var$load("jvHRs"),
    $23dde5a491238968$var$load("27glK"),
    $23dde5a491238968$var$load("bvY53"),
    $23dde5a491238968$var$load("Wowvf"),
    $23dde5a491238968$var$load("ffEVr"),
    $23dde5a491238968$var$load("fIjMV"),
    $23dde5a491238968$var$load("psI7s"),
    $23dde5a491238968$var$load("6bVVs"),
    $23dde5a491238968$var$load("7mo6o"),
    $23dde5a491238968$var$load("jnVKv"),
    $23dde5a491238968$var$load("3Zwna"),
    $23dde5a491238968$var$load("7EorR"),
    $23dde5a491238968$var$load("bgHzk"),
    $23dde5a491238968$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.eae936dc.js.map
